import React  from 'react'
import {FieldViewProps} from "../../../render/view"

const debug = false
// const debug = "FieldString_View"

export default function FieldString_View(props:FieldViewProps) {

    debug && console.log(debug, 'render', props)

    const value = _.get(props.model, props.field.fieldId, null)

    const classes = Classes("ui5-txt-default txt-truncate", props.className, {
        'invalid-value': !props.field.isValueValid(value)
    })

    const displayValue = props.field.getDisplayValue(value)

    // div title attribute is required for pseudo element :before to make bold and not bold text the same width
    return (
        <div className={classes} title={displayValue}>
            {!_.isNil(value) && _.get(props.field.components, 'ValuePrefix', false)}
            {displayValue}
        </div>
    );
}
